<template>
  <div v-show="this.$store.state.showNavbar" class="min-height-300 position-absolute w-100 bg-primary">
  </div>
</template>
<script>

export default {
  name: "index"
};
</script>
